import styled from 'styled-components';

import $Icon from 'components/Icon';
import $CircularProgressBar from 'components/CircularProgressBar';

import {commonPalette} from 'styles/palette';

import {READY_STATE} from './constants';

export const MediaUploader = styled.div.attrs(p => ({
  style: {
    backgroundImage: p.readyState === 'DONE' ? `url('${p.backgroundURL}')` : 'none',
    cursor: p.readyState === READY_STATE.EMPTY ? 'pointer' : 'auto',
    minHeight: p.isDesktop ? 200 : 174
  }
}))`
  background-color: ${commonPalette.gray};
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 3px;
  padding: ${p => (p.isImage ? '52px 36px 34px' : '0')};
  position: relative;
  height: 200px;
  &:focus {
    outline: 0;
  }
`;

export const TextWrapper = styled.div`
  color: #646464;
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
`;

export const ControlsWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 16px;
  right: 16px;
`;

export const CircularProgressBar = styled($CircularProgressBar)`
  display: block;
  margin: 0 auto 8px;
`;

export const AddPictureIcon = styled($Icon).attrs({
  name: 'multimedia',
  size: 26
})`
  color: #757575;
  display: block;
  margin: 10px auto 15px;
`;

export const CancelButton = styled.button.attrs({
  type: 'button'
})`
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: block;
  font: inherit;
  margin: 16px auto 0;
  padding: 0;
  text-decoration: underline;

  &:focus {
    outline: 0;
  }
`;

export const ControlButton = styled.button.attrs({
  type: 'button'
})`
  background: ${commonPalette.gray};
  border: 0;
  border-radius: 3px;
  cursor: pointer;
  display: block;
  padding: 8px;

  &:focus {
    outline: 0;
  }

  + ${() => ControlButton} {
    margin-top: 8px;
  }
`;

export const ControlButtonIcon = styled($Icon).attrs({
  size: 24
})`
  color: #323232;
  display: block;
`;
